import { createContext, useContext, useState, type Dispatch, type SetStateAction } from "react"

interface CampaignsContextType {
  campaigns: { id: number; name: string }[]
  setCampaigns: Dispatch<SetStateAction<{ id: number; name: string }[]>>
}

const CampaignsContext = createContext<CampaignsContextType | undefined>(undefined)

export const CampaignsProvider = ({
  initialCampaigns,
  children,
}: {
  initialCampaigns: { id: number; name: string }[]
  children: React.ReactNode
}) => {
  const [campaigns, setCampaigns] = useState(initialCampaigns)

  return <CampaignsContext.Provider value={{ campaigns, setCampaigns }}>{children}</CampaignsContext.Provider>
}

export const useCampaigns = () => {
  const context = useContext(CampaignsContext)
  if (context === undefined) {
    throw new Error("useCampaigns must be used within a CampaignsProvider")
  }
  return context
}
